import { getIbanOptions } from "@/.shared/helpers/text-box-helper";

export const useIbanField = () => {
  const ibanPattern = /^ES\d{22}$/;

  const handleIbanValueChanged = (e: any) => {
    const upperValue = e.value?.toUpperCase().replace(/ /g, "");
    const formattedValue = upperValue ? `ES${upperValue.replace(/^ES/, '')}` : null;
    e.component.option('value', formattedValue);
  };

  const getIbanFieldOptions = () => ({
    ...getIbanOptions(),
    onValueChanged: handleIbanValueChanged
  });

  return {
    ibanPattern,
    getIbanFieldOptions
  };
}; 